import React, { useState } from 'react';
import { HiX, HiMenu } from "react-icons/hi";
import {HashLink} from 'react-router-hash-link';
import logo from '../../assets/images/asset-logo-1.png';
import logo2 from '../../assets/images/asset-logo-2.png';
import moon from '../../assets/images/moon.png';
import sun from '../../assets/images/sun.png';

const Header = ({toggleDarkMode, isMoon}) => {
    const [open, setOpen] = useState(false);
    const [changeHeader, setChangeHeader] = useState(false);

    //header change function 
    const onChangeHeader = () => {
        if (window.scrollY >= 50) {
            setChangeHeader(true)
        } else {
            setChangeHeader(false)
        }
    }

    //change header by scrolling
    window.addEventListener('scroll', onChangeHeader);

    return (
        <header  className={changeHeader ? "bg-light-blue dark:bg-light-black w-full fixed top-0 left-0 shadow-md z-50" : "bg-light-blue md:bg-transparent dark:bg-light-black md:dark:bg-transparent w-full fixed top-0 left-0 z-50"}>
            <nav className="max-w-screen-xl md:flex items-center justify-between py-4 bg-transparent mx-auto  px-2">
                <div>
                    <HashLink smooth to="/#home" >
                        {isMoon ?
                            <img className='w-[100px] logo' src={logo} alt="logo" /> :
                            <img className='w-[100px] logo2' src={logo2} alt="logo" />
                        }
                    </HashLink>  
                </div>
                <div
                    onClick={() => setOpen(!open)}
                    className="h-6 w-6 absolute right-8 top-6 cursor-pointer md:hidden"
                >
                    
                    {open ? <HiX className='dark:text-white'/> : <HiMenu className='dark:text-white'/>}
                </div>
                <ul
                    className={`md:flex md:items-center md:pb-0 pb-12 border-t-[1px] mt-[7px] md:mt-0 border-orange  md:border-0 absolute md:static md:z-auto z-[40] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-700 ease-in bg-light-blue md:bg-transparent dark:bg-light-black md:dark:bg-transparent ${
                        open ? 'top-20 ' : 'top-[-490px]'
                    }`}
                >
                    <li className="md:ml-8 text-lg md:my-0 my-7 dark:text-white">
                        <HashLink smooth to="/#home" className='underline-style'>
                            HOME
                        </HashLink>
                    </li>
                    <li className="md:ml-8 text-lg md:my-0 my-7 dark:text-white">
                        <HashLink smooth to="#about" className='underline-style' >
                            ABOUT
                        </HashLink>
                    </li>
                    <li className="md:ml-8 text-lg md:my-0 my-7 dark:text-white">
                        <HashLink smooth to="#skills" className='underline-style' >
                            SKILLS
                        </HashLink>
                    </li>
                    <li className="md:ml-8 text-lg md:my-0 my-7 dark:text-white">
                        <HashLink  smooth to="/#projects" className='underline-style' >
                            PROJECTS
                        </HashLink>
                    </li>
                    {/* <li className="md:ml-8 text-lg md:my-0 my-7 dark:text-white">
                        <HashLink smooth to="/#services" className='underline-style' >
                            SERVICES
                        </HashLink>
                    </li> */}
                    <li className="md:ml-8 text-lg md:my-0 my-7 dark:text-white">
                        <HashLink smooth to="/#contact" className='underline-style' >
                            CONTACT
                        </HashLink>
                    </li>
                    <li onClick={() => {toggleDarkMode(); }} className="md:ml-8 text-lg md:my-0 my-7 cursor-pointer">
                        {isMoon ? 
                            <img className='h-[30px] moon' src={moon} alt="moon icon" /> :  
                            <img className='h-[29px] sun' src={sun} alt="sun icon" />
                        }
                    </li>            
                </ul>
            </nav>
        </header>
    );
};

export default Header;